import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ShieldCheck, Loader2, Mail, KeyRound } from "lucide-react";
import { api } from "@/lib/accessApi";

export default function Access() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // login | register
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    setLoading(true);
    try {
      await api(`/access/${mode}`, { method: "POST", body: form });
      navigate("/dashboard");
    } catch (err) {
      setMsg(typeof err.detail === "string" ? err.detail : "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(99,102,241,0.15),transparent_45%),radial-gradient(circle_at_80%_80%,rgba(14,165,233,0.12),transparent_40%)]" />
      <div className="relative w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-sky-500 shadow-lg shadow-indigo-900/40">
            <Lock className="h-6 w-6 text-white" />
          </span>
          <h1 className="mt-4 text-2xl font-bold tracking-tight text-white">Access Your Product</h1>
          <p className="mt-1 text-sm text-slate-400">{mode === "login" ? "Sign in to access what you've purchased." : "Create an account to access your purchase."}</p>
        </div>

        <div className="mb-4 flex rounded-xl border border-white/10 bg-white/5 p-1">
          {["login", "register"].map((m) => (
            <button key={m} onClick={() => { setMode(m); setMsg(null); }} data-testid={`mode-${m}`}
              className={`flex-1 rounded-lg py-2 text-sm font-medium transition-colors ${mode === m ? "bg-indigo-500 text-white" : "text-slate-300 hover:text-white"}`}>
              {m === "login" ? "Masuk" : "Daftar"}
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-xl">
          <label className="mb-1.5 block text-xs font-medium text-slate-300">Email</label>
          <div className="relative mb-4">
            <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <input
              type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="access-email" placeholder="you@example.com" autoComplete="username"
              className="w-full rounded-xl border border-white/10 bg-slate-900/60 py-3 pl-9 pr-4 text-sm text-white outline-none placeholder:text-slate-500 focus:border-indigo-400"
            />
          </div>
          <label className="mb-1.5 block text-xs font-medium text-slate-300">Password</label>
          <div className="relative mb-5">
            <KeyRound className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <input
              type="password" required minLength={mode === "register" ? 8 : undefined}
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="access-password" placeholder={mode === "register" ? "Min. 8 karakter" : "••••••••"} autoComplete={mode === "login" ? "current-password" : "new-password"}
              className="w-full rounded-xl border border-white/10 bg-slate-900/60 py-3 pl-9 pr-4 text-sm text-white outline-none placeholder:text-slate-500 focus:border-indigo-400"
            />
          </div>

          <button type="submit" disabled={loading} data-testid="access-submit"
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-indigo-500 to-sky-500 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />}
            {mode === "login" ? "MASUK" : "DAFTAR"}
          </button>

          {msg && <div data-testid="access-message" className="mt-4 rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-2.5 text-center text-sm font-medium text-red-300">{msg}</div>}
        </form>

        <p className="mt-5 flex items-center justify-center gap-1.5 text-center text-xs text-slate-500">
          <ShieldCheck className="h-3.5 w-3.5" /> Akses diberikan hanya setelah pembayaran berhasil.
        </p>
      </div>
    </div>
  );
}
